import {
  SIS_USER_CUSTOM_FIELD_KEYS,
  SisUserCustomFieldKey,
} from '../constants/sisUserCustomFields';

export const buildUserCustom = (
  fields: Partial<Record<SisUserCustomFieldKey, string | undefined>>,
) => {
  const custom = SIS_USER_CUSTOM_FIELD_KEYS.reduce(
    (acc, key) => {
      const value = fields[key]?.trim();
      if (value) {
        acc[key] = value;
      }
      return acc;
    },
    {} as Record<SisUserCustomFieldKey, string>,
  );

  return Object.keys(custom).length ? custom : undefined;
};

export const formatUserToSave = ({
  admin,
  staff,
  email,
  studentId,
  degreeCourse,
  ...user
}: {
  admin?: boolean;
  staff?: boolean;
  email: string;
  studentId?: string;
  degreeCourse?: string;
  [key: string]: unknown;
}) => {
  const toSave: Record<string, unknown> = {
    ...user,
    email: email.toLowerCase(),
    userRoles: ['general'],
  };

  if (admin) {
    (toSave.userRoles as string[]).push('admin');
  }
  if (staff) {
    (toSave.userRoles as string[]).push('staff');
  }

  const custom = buildUserCustom({ studentId, degreeCourse });
  if (custom) {
    toSave.custom = custom;
  }

  return toSave;
};

export const mergeUserCustomFields = (
  existingCustom: Record<string, unknown> | undefined,
  fields: Partial<Record<SisUserCustomFieldKey, string | undefined>>,
) => {
  const custom = { ...(existingCustom || {}) };

  SIS_USER_CUSTOM_FIELD_KEYS.forEach((key) => {
    if (!(key in fields)) {
      return;
    }
    const trimmed = fields[key]?.trim();
    if (trimmed) {
      custom[key] = trimmed;
    } else {
      delete custom[key];
    }
  });

  return custom;
};
